import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'Marcos Oliveira',
    role: 'Proprietário',
    company: 'Barbearia Premium',
    image: 'https://public.readdy.ai/ai/img_res/abccc12296c014d8e515a32b6dee999d.jpg',
    quote: 'Antes eu perdia clientes porque não conseguia responder rápido. Agora a IA agenda automaticamente e minha agenda está sempre cheia.',
    rating: 5,
    metric: '+40% agendamentos',
  },
  {
    name: 'Dra. Camila Santos',
    role: 'Diretora Clínica',
    company: 'Clínica Estética Renova',
    image: 'https://readdy.ai/api/search-image?query=brazilian-woman-doctor-age-42-long-brown-hair-wearing-white-medical-coat-elegant-professional-warm-smile-confident-expression-neutral-background-medical-professional-portrait-studio-lighting&width=200&height=200&seq=owner-camila-santos&orientation=squarish',
    quote: 'O follow-up automático recuperou pacientes que tinham sumido. Em 2 meses, aumentamos 35% no faturamento.',
    rating: 5,
    metric: '+35% faturamento',
  },
  {
    name: 'Ricardo Mendes',
    role: 'Corretor de Imóveis',
    company: 'RM Imobiliária',
    image: 'https://readdy.ai/api/search-image?query=brazilian-real-estate-agent-man-age-45-gray-hair-wearing-navy-blue-suit-white-shirt-confident-businessman-friendly-smile-professional-corporate-headshot-neutral-background-executive-portrait&width=200&height=200&seq=owner-ricardo-mendes&orientation=squarish',
    quote: 'Eu recebia 50 mensagens por dia e não dava conta. A NeuroAgents qualifica os leads automaticamente.',
    rating: 5,
    metric: '50+ leads/dia',
  },
  {
    name: 'Ana Paula Ferreira',
    role: 'Proprietária',
    company: 'Studio Fitness AP',
    image: 'https://readdy.ai/api/search-image?query=brazilian-woman-fitness-instructor-age-35-athletic-build-blonde-ponytail-wearing-sporty-tank-top-energetic-smile-confident-posture-gym-background-blurred-professional-fitness-portrait-natural-lighting&width=200&height=200&seq=owner-ana-paula-ferreira&orientation=squarish',
    quote: 'Minha equipe não precisa mais ficar no WhatsApp o dia todo. A IA responde dúvidas e cobra mensalidades.',
    rating: 5,
    metric: '6h economizadas/dia',
  },
  {
    name: 'Fernando Costa',
    role: 'Gerente Comercial',
    company: 'AutoPrime Veículos',
    image: 'https://readdy.ai/api/search-image?query=brazilian-car-salesman-man-age-38-short-brown-hair-clean-shaven-wearing-light-blue-dress-shirt-professional-friendly-smile-automotive-dealership-background-corporate-portrait-professional-lighting&width=200&height=200&seq=owner-fernando-costa&orientation=squarish',
    quote: 'Vendemos carros pelo WhatsApp agora. A IA apresenta os veículos e agenda test-drive.',
    rating: 5,
    metric: '+25 vendas/mês',
  },
  {
    name: 'Juliana Rocha',
    role: 'CEO',
    company: 'JR Consultoria Digital',
    image: 'https://readdy.ai/api/search-image?query=brazilian-businesswoman-age-36-shoulder-length-dark-hair-wearing-elegant-gray-blazer-professional-confident-smile-modern-office-background-executive-portrait-corporate-photography-natural-lighting&width=200&height=200&seq=owner-juliana-rocha&orientation=squarish',
    quote: 'Implementei para meus próprios clientes e virou um diferencial competitivo.',
    rating: 5,
    metric: '15 clientes indicados',
  },
];

export default function ClientTestimonialsSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-gray-950 to-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-48 sm:w-96 h-48 sm:h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-48 sm:w-96 h-48 sm:h-96 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span
            className={`inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-primary/10 text-primary text-xs sm:text-sm font-semibold rounded-full mb-4 sm:mb-6 transition-all duration-700 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Depoimentos Reais
          </span>
          <h2
            className={`text-2xl sm:text-3xl md:text-5xl font-bold mb-4 sm:mb-6 transition-all duration-700 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '100ms' }}
          >
            O Que Nossos <span className="text-primary">Clientes</span> Dizem
          </h2>
          <p
            className={`text-gray-400 text-sm sm:text-lg max-w-2xl mx-auto px-2 transition-all duration-700 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '200ms' }}
          >
            Empresários reais que transformaram seu atendimento com a NeuroAgents
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:border-primary/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-primary/5 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              {/* Rating */}
              <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm sm:text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-gray-300 text-xs sm:text-base leading-relaxed mb-4 sm:mb-6 min-h-[60px] sm:min-h-[80px]">
                "{testimonial.quote}"
              </blockquote>

              {/* Metric Badge */}
              <div className="inline-flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 bg-primary/10 text-primary text-xs sm:text-sm font-semibold rounded-full mb-4 sm:mb-6">
                <i className="ri-line-chart-line"></i>
                {testimonial.metric}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4 pt-3 sm:pt-4 border-t border-gray-800">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-10 h-10 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-primary/30"
                />
                <div>
                  <p className="font-bold text-white text-xs sm:text-base">{testimonial.name}</p>
                  <p className="text-[10px] sm:text-sm text-gray-400">{testimonial.role}</p>
                  <p className="text-[10px] sm:text-sm text-primary font-medium">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div
          className={`mt-10 sm:mt-16 flex flex-wrap justify-center items-center gap-4 sm:gap-8 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '900ms' }}
        >
          <div className="flex items-center gap-2 sm:gap-3 text-gray-400">
            <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center bg-green-500/10 rounded-full">
              <i className="ri-verified-badge-fill text-green-500 text-lg sm:text-2xl"></i>
            </div>
            <span className="text-[10px] sm:text-sm font-medium">Depoimentos Verificados</span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 text-gray-400">
            <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center bg-primary/10 rounded-full">
              <i className="ri-shield-check-fill text-primary text-lg sm:text-2xl"></i>
            </div>
            <span className="text-[10px] sm:text-sm font-medium">Resultados Reais</span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 text-gray-400">
            <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center bg-yellow-500/10 rounded-full">
              <i className="ri-star-fill text-yellow-500 text-lg sm:text-2xl"></i>
            </div>
            <span className="text-[10px] sm:text-sm font-medium">4.9/5 Avaliação Média</span>
          </div>
        </div>
      </div>
    </section>
  );
}
